import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading font-semibold text-background-50 mb-4">歪歪漫画网</h4>
            <p className="text-sm leading-relaxed text-foreground-400">
              歪歪漫画网提供歪歪漫画在线免费观看与在线阅读服务，囊括海量好看漫画全集。随时随地免费看韩漫、日漫、国漫，支持下拉式阅读模式。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/hanman" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">韩漫在线免费观看</Link>
              <Link to="/category/riman" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">日漫在线免费阅读</Link>
              <Link to="/category/guoman" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">国漫免费大全</Link>
              <Link to="/category/scroll" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">下拉式漫画</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门推荐</h4>
            <div className="flex flex-col gap-2">
              <Link to="/comic/2" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">重生之都市修仙</Link>
              <Link to="/comic/8" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">全职高手之巅峰荣耀</Link>
              <Link to="/comic/7" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">我的ID是江南美人</Link>
              <Link to="/comic/1" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">霸道总裁的契约新娘</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">品牌介绍</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">联系我们</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">用户口碑</Link>
            </div>
          </div>
        </div>
        <div className="border-t border-foreground-700/30 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 歪歪漫画网 waiwaimanhua.com 版权所有 | 歪歪漫画在线免费观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}